/**
 * Catalog schema normalization utilities
 */

import { CatalogSchema } from '../types/navigation';

/**
 * Normalize typesByKind to a Map structure
 */
export function normalizeTypesByKind(
  typesByKind: Map<string, Set<string>> | any
): Map<string, Set<string>> {
  if (typesByKind instanceof Map) {
    return typesByKind;
  }

  if (Array.isArray(typesByKind)) {
    return new Map(
      typesByKind.map(([kind, types]: [string, string[]]) => [
        kind,
        new Set(types),
      ])
    );
  }

  return new Map<string, Set<string>>();
}

/**
 * Normalize a catalog schema to ensure consistent structure
 */
export function normalizeCatalogSchema(
  schema: CatalogSchema
): CatalogSchema {
  return {
    ...schema,
    typesByKind: normalizeTypesByKind(schema.typesByKind),
  };
}
